const typeOf = (value) => ({}.toString
    .call(value)
    .match(/\s([A-Za-z]+)/)[1]
    .toLowerCase());
export default typeOf;
//# sourceMappingURL=type-of.js.map